import Big from "big.js"
import { format } from "date-fns"
import { CustomTableRef, Modal, CustomTable, formatCurrency } from "medere-ui-framework"
import { Column } from "primereact/column"
import { Dispatch, SetStateAction, useState, useRef, useEffect } from "react"
import { ItemVaucher, MAX_DECIMAL, TaxType } from "../../interface/orderOfProvision"
import { findAAById } from "../../servicesHooks/Accounting/useAccountingService"
import { usePaymentOrder } from "../../components/context/PaymentOrderContext"
import { PaidTax, useTaxesPaid } from "../../components/context/TaxesPaidContext"

interface AccountingModalProps {
    visible: boolean
    setVisible: Dispatch<SetStateAction<boolean>>
    data: {
        supplier: any,
        items: ItemVaucher[],
        taxes: PaidTax[] | undefined,
        date: Date,
        formType: any,
        formNumber: string
    }
    isInverse: boolean
}    
export default function AccountingModal({ visible, setVisible, data, isInverse = false}: AccountingModalProps) {

    const [items, setItems] = useState<any[]>([])
    const tableRef = useRef<CustomTableRef>(null)
    const {paidTaxes, convertDuplicateItems, convertDuplicateTaxes} = useTaxesPaid();

    useEffect(() => {
        let _taxes: PaidTax[] = []
        let _items: ItemVaucher[] = []
        _taxes = convertDuplicateTaxes(paidTaxes)

        _items = convertDuplicateItems(data.items)
        const _totalAmountTaxes = _taxes.reduce((acumulator, tax) => acumulator + Number(tax.amount), 0)
        const _totalAmountItems = _items.reduce((acumulator, item) => acumulator.plus(item.amount), Big(0))
        const _total = _totalAmountItems.plus(_totalAmountTaxes)
        const _accountingAccount = data.supplier?.debit
        if (!_accountingAccount) return
        findAAById({accountingAccountId: _accountingAccount }).then((resp) => {
            const _resp = {
                isSupplier: true,
                account: {
                    ...resp
                },
                credit: Big(_total).toFixed(MAX_DECIMAL),
            }
            setItems([..._taxes, ..._items, _resp])
        })

        return (() => {
            setItems([])
        })
    }, [])

    useEffect(() => {
        if (tableRef.current && tableRef.current.refreshTable) {
            tableRef.current.refreshTable()
        }

    }, [items])

    const AccountingInverse = () => (
        <CustomTable
            idTable='AccountingAccountAutomaticTable'
            getItems={getItems}
            resizableColumns
            hideFiltersButton
            ref={tableRef}
        >
            <Column body={(e) => {
                return e.taxAccountIdentifier ?? e?.account?.identifier
            }} header='Cuenta' className="column" />
            <Column body={(e) => {
                return e.taxAccountName ?? e?.account?.description ?? 'No tiene una cuenta asociada'
            }} header='' className="column" />
            <Column body={(e) => {
                if (!e?.isSupplier) {
                    return ''
                }
                return formatCurrency(Number(Big(e.credit).toFixed(MAX_DECIMAL)))
            }} header='Debe' className="column" />
            <Column body={(e) => {
                let _value
                if (e.taxValue) {
                    _value = e.taxValue
                } else if (e.amount) {
                    _value = e.amount
                } else {
                    return ''
                }
                const isNan = !isNaN(Number.parseInt(Big(_value).toString()))
                return isNan ? formatCurrency(Number(Big(_value).toFixed(MAX_DECIMAL))) : ''
            }} header='Haber' className="column" />

        </CustomTable>
    )

    function getItems() {
        return Promise.resolve(items)
    }

    return (
        <Modal
            visible={visible}
            setVisible={setVisible}
            header='Asiento generado automaticamente'
        >
            <header className="flex flex-row gap-2 mb-2">
                <h3>{data.date && format(data.date, 'dd/MM/yyyy')}</h3>
                <h3>{`${data.formType?.description ?? 'Comprobante'} - ${data?.formNumber}`}</h3>
            </header>
            <div className="flex flex-column min-h-200">
                {isInverse ? <AccountingInverse /> : (
                    <CustomTable
                        idTable='AccountingAccountAutomaticTable'
                        className="accountingModalTable"
                        getItems={getItems}
                        resizableColumns
                        hideFiltersButton
                        ref={tableRef}
                    >
                        <Column body={(e) => {
                            return e.taxAccountIdentifier ?? e?.account?.identifier
                        }} header='Cuenta' className="column" />
                        <Column body={(e) => {
                            return e.taxAccountName ?? e?.account?.description ?? 'No tiene una cuenta asociada'
                        }} header='' className="column" />
                        <Column body={(e) => {
                            let _value
                            if (e.taxValue) {
                                _value = e.taxValue
                            } else if (e.amount) {
                                _value = e.amount
                            } else {
                                return ''
                            }
                            const isNan = !isNaN(Number.parseInt(Big(_value).toString()))
                            return isNan ? formatCurrency(Number(Big(_value).toFixed(MAX_DECIMAL))) : ''
                        }} header='Debe' className="column" />
                        <Column body={(e) => {
                            if (!e?.isSupplier) {
                                return ''
                            }
                            return formatCurrency(Number(Big(e.credit).toFixed(MAX_DECIMAL)))
                        }} header='Haber' className="column" />
                    </CustomTable>)}
            </div>
        </Modal>
    )
}
